/*
 * @Author: your name
 * @Date: 2020-10-23 09:30:49
 * @LastEditTime: 2021-05-18 16:27:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\api\home\users-trial.js
 */
import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取试用用户列表
  getTrialUserList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysTrialUser/page`, { params });
  },
  // 导出
  getExport(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysTrialUser/export`, {
      params,
      responseType: 'blob'
    });
  }
};
